import type React from 'react'

export enum AccordionVariant {
	Primary = 'primary',
	Secondary = 'secondary',
	Tertiary = 'tertiary',
}
export interface AccordionProps {
	filled?: boolean
	data: AccordionData[]
	id: string
	hasBorderBottom?: boolean
	shouldRenderOnExpand?: boolean
	variant?: AccordionVariant
}

export interface AccordionData {
	title: string | React.ReactNode
	content: React.ReactNode
	subtitle?: string
	dataTestId?: string
	onClick?: (expanded: boolean) => void
	onExpanded?: (id: string, setSubtitle: (subtitle: string) => void) => void
	onCollapsed?: (id: string, setSubtitle: (subtitle: string) => void) => void
	onExpandedStart?: (
		id: string,
		setSubtitle: (subtitle: string) => void
	) => void
	onCollapsedStart?: (
		id: string,
		setSubtitle: (subtitle: string) => void
	) => void
	showExpanded?: boolean
	shouldScroll?: boolean
	hide?: boolean
}

export interface ElementProps {
	filled?: boolean
	title: string | React.ReactNode
	subtitle?: string
	id: string
	children: React.ReactNode
	onExpanded?: (id: string, setSubtitle: (subtitle: string) => void) => void
	onCollapsed?: (id: string, setSubtitle: (subtitle: string) => void) => void
	onExpandedStart?: (
		id: string,
		setSubtitle: (subtitle: string) => void
	) => void
	onCollapsedStart?: (
		id: string,
		setSubtitle: (subtitle: string) => void
	) => void
	dataTestId?: string
	onClick?: (
		expanded: boolean,
		scrollRef: React.RefObject<HTMLDivElement | null>
	) => void
	showExpanded?: boolean
	shouldScroll?: boolean
	shouldRenderOnExpand?: boolean
	variant?: AccordionVariant
}
